<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4">
            <h6 class="text-muted" v-text="fss.rliss"></h6>
            <h5 v-text="fss.agence"></h5>
            <p style="line-height: 1;">
              <small>
                <template v-if="aDuContenu(fss.adresse.po_box)">
                  {{fss.adresse.po_box}}<br />
                </template>
                <template v-if="aDuContenu(fss.adresse.unit_number)">
                  {{fss.adresse.unit_number}}-</template
                >{{fss.adresse.street_number}} {{fss.adresse.street_name}}<br />
                {{fss.adresse.city}} {{fss.adresse.province}} {{fss.adresse.postal_code}}
              </small>
            </p>
          </div>
          <div class="col-sm-8">
            <OlCommon :address='addressAsString'></OlCommon>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12">
        <table class="table table-sm table-bordered" style="table-layout: fixed">
          <col style="width:30%">
          <col style="width:30%">
          <col style="width:30%">
          <col style="width:10%">
          <thead>
            <tr>
              <th></th>
              <th v-text='fss.p1920.period'></th>
              <th v-text='fss.p2021.period'></th>
              <th>Différence</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Statut du FSS</td>
              <td v-text='fss.p1920.agency_status_fr'></td>
              <td v-text='fss.p2021.agency_status_fr'></td>
              <td>
                <span v-if="fss.p1920.agency_status_fr != fss.p2021.agency_status_fr"
                class="badge badge-primary">Changement</span>
              </td>
            </tr>
            <tr>
              <td>Statut du plan</td>
              <td v-text='fss.p1920.statut_plan'></td>
              <td v-text='fss.p2021.statut_plan'></td>
              <td></td>
            </tr>
            <tr>
              <td>Clientèle - période</td>
              <td v-text='fss.p1920.client_year'></td>
              <td v-text='fss.p2021.client_year'></td>
              <td>
                <span v-if="fss.p1920.client_year==fss.p2021.client_year"
                class="badge badge-warning">Aucun changement</span>
              </td>
            </tr>
            <tr>
              <td>Clientèle (fr / <span class="text-muted">total</span>)</td>
              <td>{{fss.p1920.client_french_population}} /
                <span class="text-muted">{{fss.p1920.client_total_population}}</span>
              </td>
              <td>{{fss.p2021.client_french_population}} /
                <span class="text-muted">{{fss.p2021.client_total_population}}</span>
              </td>
              <td>
                <DiffPourcentage :val1="fss.p1920.client_total_population"
                  :val2="fss.p2021.client_total_population">
                </DiffPourcentage>
              </td>
            </tr>

            <tr>
              <td>Visites (fr / <span class="text-muted">total</span>)</td>
              <td>{{fss.p1920.client_french_visits}} /
                <span class="text-muted">{{fss.p1920.client_visits}}</span>
              </td>
              <td>{{fss.p2021.client_french_visits}} /
                <span class="text-muted">{{fss.p2021.client_visits}}</span>
              </td>
              <td>
                <DiffPourcentage :val1="fss.p1920.client_visits"
                  :val2="fss.p2021.client_visits">
                </DiffPourcentage>
              </td>
            </tr>

            <tr>
              <td>Identifie les francophone</td>
              <td v-text='ouiNon(fss.p1920.identifie_les_francos)'></td>
              <td v-text='ouiNon(fss.p2021.identifie_les_francos)'></td>
              <td>
                <span v-if="fss.p1920.identifie_les_francos != fss.p2021.identifie_les_francos"
                  class="badge badge-primary">Changement</span>
              </td>
            </tr>
            <tr>
              <td>Réfère les francophone</td>
              <td v-text='ouiNon(fss.p1920.refere)'></td>
              <td v-text='ouiNon(fss.p2021.refere)'></td>
              <td>
                <span v-if="fss.p1920.refere != fss.p2021.refere"
                  class="badge badge-primary">Changement</span>
              </td>
            </tr>
            <tr>
              <td>Capture la satisfaction des francophones</td>
              <td v-text='ouiNon(fss.p1920.capture_la_satisfaction)'></td>
              <td v-text='ouiNon(fss.p2021.capture_la_satisfaction)'></td>
              <td>
                <span v-if="fss.p1920.capture_la_satisfaction != fss.p2021.capture_la_satisfaction"
                  class="badge badge-primary">Changement</span>
              </td>
            </tr>
            <tr>
              <td>Jumelage avec personnel francophone</td>
              <td v-text='ouiNon(fss.p1920.jumelage)'></td>
              <td v-text='ouiNon(fss.p2021.jumelage)'></td>
              <td>
                <span v-if="fss.p1920.jumelage != fss.p2021.jumelage"
                  class="badge badge-primary">Changement</span>
              </td>
            </tr>
            <tr>
              <td>Postes et compétences</td>
              <td>
                <template v-for='poste in fss.p1920.rh'>
                  <span v-if="poste.actuel != 0" :key="poste.profil_linguistique">
                    ({{poste.actuel}}) {{poste.functional_center_en}} - {{poste.position_title}} ({{poste.profil_linguistique}})
                    <template v-if="fss.p1920.agency_status_id!=4">
                      / {{poste.requis}}
                    </template><br />
                  </span>
                </template>
                <template v-if="fss.p1920.agency_status_id!=4">
                  À évaluer: {{totalDePostesAEvaluer(fss.p1920.rh)}}
                </template>
              </td>

              <td>
                <template v-for='poste in fss.p2021.rh'>
                  <span  v-if="poste.actuel != 0" :key="poste.profil_linguistique">
                    ({{poste.actuel}}) {{poste.functional_center_en}} - {{poste.position_title}} ({{poste.profil_linguistique}})
                    <template v-if="fss.p2021.agency_status_id!=4">
                      / {{poste.requis}}
                    </template><br />
                  </span>
                </template>
                <template v-if="fss.p2021.agency_status_id!=4">
                  À évaluer: {{totalDePostesAEvaluer(fss.p2021.rh)}}
                </template>
              </td>

              <td>
                <DiffPourcentage :val1="totalDePostesActuels(fss.p1920.rh)"
                  :val2="totalDePostesActuels(fss.p2021.rh)">
                </DiffPourcentage>
                <template v-if="fss.p1920.agency_status_id!=4"> /
                  <DiffPourcentage :val1="totalDePostesRequis(fss.p1920.rh)"
                    :val2="totalDePostesRequis(fss.p2021.rh)">
                  </DiffPourcentage>
                </template>
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DiffPourcentage from '@/components/common/DiffPourcentage.vue'
import OlCommon from '@/components/common/OlCommon.vue'

export default {
  name: 'OnFssDetail',
  props: {
    fss: Object
  },
  components: {
    DiffPourcentage, OlCommon
  },
  computed: {
    addressAsString() {
      if(! this.fss.adresse)
        return "";
      return this.fss.adresse.street_number + " "
        + this.fss.adresse.street_name + ", "
        + this.fss.adresse.city + ", "
        + this.fss.adresse.province
    }

  },
  methods: {
    aDuContenu(val) {
      if(val==null || val=="")
        return false;
      return true;
    },
    ouiNon(val) {
      return val ? 'Oui' : 'Non';
    },
    changementPourcent(val1, val2) {
      if(val1 == 0)
        return "Nouvelle valeur";
        // return "test";
      const diff = 100*(val2-val1)/val1;
      return diff.toFixed(2)+"%";
    },
    totalDePostesActuels(postes) {
      if(postes.length==0)
        return 0;
      return postes.reduce((a, b) => ({actuel: a.actuel + b.actuel})).actuel;
    },
    totalDePostesRequis(postes) {
      if(postes.length==0)
        return 0;
      return postes.reduce((a, b) => ({requis: a.requis + b.requis})).requis;
    },
    totalDePostesAEvaluer(postes) {
      if(postes.length==0)
        return 0;
      return postes.reduce((a, b) => ({a_eval: a.a_eval + b.a_eval})).a_eval;
    }
  }
}
</script>
